import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import buyersImage from '../../../assets/images/buyers.png';
import styles from '../WhySellAtCatawiki.module.scss';

export const BuyerBlock = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.keyPointsBlock}>
      <Image
        width={305}
        height={240}
        src={buyersImage}
        unoptimized
        alt="buyers_illustration"
      />
      <h3 className="u-typography-h3 u-m-t-xxl-4">
        {t('seller_register.why.buyers_title')}
      </h3>
      <h5 className="u-typography-h5 u-m-t-m u-color-secondary">
        {t('seller_register.why.buyers_subtitle')}
      </h5>
    </div>
  );
};
